// extracted by mini-css-extract-plugin
export default {"container":"Global_container__RZWZA","body":"Global_body__Jz9NH"};